module.exports = __webpack_public_path__ + "img/app-mockup-recording.366f766c.png";